<section class="tw-mx-4 tw-mb-4 tw-p-4 tw-bg-white tw-shadow-z1 tw-rounded-2xl">
  <div class="header tw-flex tw-flex-wrap tw-items-center tw-gap-2 tile-wrapper xs:tw-flex-nowrap">
    <div class="tw-font-body tw-font-bold tw-text-400 tw-mr-1 tw-items-center tw-flex tw-min-h-12" i18n="@@orderPrepration">We are preparing your treatment kit</div>
    @if (acqRebranding2025) {
      <button csButton size="small" (click)="handleClick()">
        <span i18n="@@clickHere">Click Here</span>
      </button>
    } @else {
      <cs-button [class]="'tw-w-32 primary btn-xxxs btn-xxxs-padding tw-px-2 btn-float'" (callback)="handleClick()"><cs-button-text i18n="@@clickHere">Click Here</cs-button-text></cs-button>
    }
  </div>
</section>